import { Box, styled } from '@planne-software/uni/mui/material';

export const PriceStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 0,
});

export const SinglePrice = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-semibold'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-strongest'],
  whiteSpace: 'nowrap',
}));

export const OldPriceLine = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-xs-regular'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-base'],
  textDecoration: 'line-through',
  whiteSpace: 'nowrap',
}));

export const CurrentPrice = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-semibold'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-strongest'],
  whiteSpace: 'nowrap',
}));
